class OptionPopup extends HTMLElement {
  constructor() {
    super();

    this.handleToggle = (e) => {
      if (e.detail.id !== this.dataset.controlledBy) return;
      this.opener = e.target;
      this._toggle();
    };

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this._close();
      }
    };

    document.addEventListener("focusout", (e) => {
      if (this.contains(e.relatedTarget)) return;

      this._close();
    });

    this.addEventListener("aria-listbox:change", () => this._close());
  }

  connectedCallback() {
    document.addEventListener("option-popup:toggle", this.handleToggle);
    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("option-popup:toggle", this.handleToggle);
    document.removeEventListener("keydown", this.closeEsc);
  }

  _toggle() {
    if (this.hasAttribute("open")) {
      this._close();
    } else {
      this._open();
    }
  }

  _open() {
    if (this.isOpen) return;
    this.removeEventListener("transitionend", this.onEnd);
    this.isOpen = true;
    this.onEnd = () => {
      this.removeEventListener("transitionend", this.onEnd);
      this.querySelector("aria-listbox").setAttribute("active", "");
    };

    this.addEventListener("transitionend", this.onEnd);

    this.opener.setAttribute("aria-expanded", "true");
    this.style.display = null;

    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
    });
  }

  _close() {
    if (!this.isOpen) return;
    this.removeEventListener("transitionend", this.onEnd);

    this.onEnd = () => {
      this.removeEventListener("transitionend", this.onEnd);
      this.opener.setAttribute("aria-expanded", "false");
      this.querySelector("aria-listbox").removeAttribute("active");
      this.style.display = "none";
      this.isOpen = false;
      this.opener.focus();
    };

    this.addEventListener("transitionend", this.onEnd);

    this.removeAttribute("open");
  }
}

if (!customElements.get("option-popup")) {
  customElements.define("option-popup", OptionPopup);
}
